import BaseHelper from './moment-base';
import moment from 'moment';

export default class IsBetween extends BaseHelper {
  compute(
    [date, dateA, dateB],
    { precision = 'year', inclusivity = '[)' } = {},
  ) {
    super.compute(...arguments);
    if (!date || !dateA || !dateB) {
      return false; // Return false if any required date is missing
    }
    return moment(date).isBetween(
      moment(dateA),
      moment(dateB),
      precision,
      inclusivity,
    );
  }
}
